import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, Observable, throwError } from "rxjs";
import { AuthService } from "../../auth/services";

export const authInterceptor : HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
) : Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);
    const token = authService.token();

    if(!token){
        return next(req);
    }

    // Token exists but is expired → logout and cancel auth header
    if (authService.isTokenExpired(token)) {
        authService.logout();
        return next(req);
    }

    const authReq = req.clone({
        setHeaders: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
    });

    return next(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
                authService.logout();
            }
            return throwError(() => error);
        })
    );
}